import { isEqual } from 'lodash'

export const existsInArray = (obj, array) => {
  return array?.some((item) => isEqual(item, obj)) ?? []
}
